import { AddressBookEntry } from '~/address-book/model/reducer'
import { apolloClient } from '~/apollo'
import {
  AddressBookEntryInput,
  AddressServiceQueryDocument,
  CreateAddressMutationDocument,
  DeleteAddressMutationDocument,
  EditAddressMutationDocument,
} from '~/gql'

import { AddressValidator } from './addressValidator'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mutateContact(variables: any, mutation: any): Promise<any> {
  const result = new Promise((resolve, eject) => {
    apolloClient
      .mutate({
        mutation,
        variables,
      })
      // eslint-disable-next-line @typescript-eslint/no-shadow
      .then((result) => {
        resolve(result.data)
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err)
        eject(err)
      })
  })
  return result
}

export const createAddressBookEntry = async (addressBookEntry: AddressBookEntry) => {
  const {
    addressbook: {
      createAddress: { id },
    },
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
  } = await mutateContact({ abe: getAddressBookEntry(addressBookEntry) }, CreateAddressMutationDocument)

  return id
}

export const updateAddressBookEntry = (addressBookEntry: AddressBookEntry) =>
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  mutateContact({ id: addressBookEntry.id, abe: getAddressBookEntry(addressBookEntry) }, EditAddressMutationDocument)

export const deleteAddressBookEntry = (id: string) => mutateContact({ id }, DeleteAddressMutationDocument)

export const queryAddressBook = (
  searchTerm: string,
  country: string | null,
  max: number | null,
  clearCache: boolean
): Promise<AddressBookEntry[]> =>
  apolloClient
    .query({
      query: AddressServiceQueryDocument,
      fetchPolicy: clearCache ? 'no-cache' : 'cache-first',
      variables: {
        max: max || 250,
        searchTerm,
        countries: country ? [country] : [],
      },
    })
    .then((result) => {
      const {
        addressbook: { addresses },
      } = result.data
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      return sanitizeAddressBook(addresses)
    })

/* The GraphQL query does not allow to filter out DEFAULT_SHIPPER, so we do it manually */
export const sanitizeAddressBook = (addresses: AddressBookEntry[]): AddressBookEntry[] =>
  addresses
    .filter((address: AddressBookEntry) => !address.tags.includes('DEFAULT_SHIPPER'))
    .sort((addr1, addr2) => {
      const name1 = addr1.name.companyName ? addr1.name.companyName : addr1.name.firstName || '0'
      const name2 = addr2.name.companyName ? addr2.name.companyName : addr2.name.firstName || '0'
      // eslint-disable-next-line no-nested-ternary
      return name1.toLowerCase() > name2.toLowerCase() ? 1 : name1.toLowerCase() === name2.toLowerCase() ? 0 : -1
    })

export const queryDefaultShipper = (): Promise<AddressBookEntry> =>
  apolloClient
    .query({
      query: AddressServiceQueryDocument,
      variables: {
        max: 1,
        tags: ['DEFAULT_SHIPPER'],
      },
    })
    .then((result) => {
      const {
        addressbook: { addresses },
      } = result.data
      return addresses.length === 0 ? null : addresses[0]
    })

const cleanZipcode = (zipCode: string, countryCode: string) =>
  AddressValidator.normalizedPostalCode(countryCode, zipCode)

export function getAddressBookEntry(contact: AddressBookEntry): AddressBookEntryInput {
  const address = { ...contact.address, ...{ isBusiness: false } }

  if (address.zipCode && address.countryCode) {
    // @ts-ignore
    address.zipCode = cleanZipcode(address.zipCode, address.countryCode)
  }

  const { name, tags } = contact

  return {
    tags: Object.assign([], tags),
    email: {
      address: contact.email || '',
    },
    phoneNumber: contact.phoneNumber || '',
    name,
    address,
  }
}
